import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import SvgIcon from '@material-ui/core/SvgIcon';

import ExpandMoreIcon from '../../../../icons/expand-more.svg';
import './BusinessHours.scss'

export default function BusinessHours(props) {

  const businessHours = {
    headers: ['Time Zone', 'Open From'],
    content: [
      ['Eastern Time Zone (ET)', '8:00 AM to 7:30 PM']
    ]
  }

  return (
    <Accordion className="business-hours mb-3">
      <AccordionSummary
        expandIcon={<SvgIcon component={ExpandMoreIcon} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className="p-0 m-0 justify-content-start"
      >
        <p className="m-0">Business Hours</p>
      </AccordionSummary>
      <AccordionDetails className="flex-column p-0 pb-4">
        <Row><Col className='mb-3'>Monday through Friday</Col></Row>
        <Row>
          {businessHours.headers.map((h, index) =>
            <Col key={index} xs={6}><p className="summary-details-label">{h}</p></Col>
          )}
        </Row>

        {businessHours.content.map((item, index) =>
          <Row key={index}>
            {item.map((text, j) =>
              <Col key={j} xs={6} className="mt-auto"><p className="summary-details-business-time">{text}</p></Col>
            )}
          </Row>
        )}
      </AccordionDetails>
    </Accordion>
  )
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/BusinessHours.js